import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDriversLocations } from '../../services/MapsService';
import { LocationDriversResponse } from '../../types/Maps';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDriversLocations(fleetId: string, query: string): UseQueryResult<LocationDriversResponse> {
  return useQuery(
    ['driversLocations', fleetId, query],
    async (): Promise<LocationDriversResponse> => getDriversLocations(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      keepPreviousData: true,
    },
  );
}

export default useGetDriversLocations;
